// extracted by mini-css-extract-plugin
module.exports = {"select":"LanguageSelect_select___JWYb","currentFlag":"LanguageSelect_currentFlag__186GY","flags":"LanguageSelect_flags__2p097"};